import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Link } from '@hivebrite/design-system/Link';

import Info from 'hb-react/shared/icons/Info';

/**
 * @deprecated please use `@hivebrite/design-system/Infobox` instead
 */
const InfoBoxWithLink = ({ children, parent, parentType, adminName }) => {
  const isFromTopic = parentType === 'Topics::Topic';

  return (
    <Box alignItems="center">
      <Box mr={3} flexShrink={0}>
        <Info width={25} height={25} />
      </Box>
      <Box>
        {children}
        {isFromTopic ? (
          <StyledLink
            to={Routes.edit_backoffice_network_topic_path(
              parent.network_id,
              parent.id,
            )}
            rel="nofollow"
            ml={1}
          >
            {parent.name}
          </StyledLink>
        ) : (
          <Box ml={1}>{parent.title}</Box>
        )}
        {adminName && (
          <Box ml={1}>{__('by %{adminName}').i__({ adminName })}</Box>
        )}
      </Box>
    </Box>
  );
};

export default InfoBoxWithLink;

const StyledLink = styled(Link)`
  text-decoration: none;
`;
